import React from 'react';
import { AudioActionButton } from 'app/components/Song/Audio/AudioActionButton';
import { ErrorOutline24 } from '@carbon/icons-react';
import { ListItem } from 'app/components/ChakraTableList';
import { Icon, SystemStyleObject } from '@chakra-ui/react';
import { DataTestId } from 'types/general.types';

interface AudioPlayControlsComponentProps extends DataTestId {
  isLoading?: boolean;
  isActive?: boolean;
  isError?: boolean;
  handlePlay: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => Promise<void>;
  isPlaying: boolean;
  isPlayerTheme?: boolean;
  sx?: SystemStyleObject;
}

export const AudioPlayControlsComponent: React.FC<AudioPlayControlsComponentProps> = ({
  isLoading,
  isActive,
  isError,
  handlePlay,
  isPlaying,
  isPlayerTheme,
  'data-testid': dataTestId,
  sx,
}) => (
  <ListItem sx={sx}>
    {isError ? (
      <Icon
        width={5}
        height={5}
        as={ErrorOutline24}
        data-testid="audio-controls-error"
        color={isPlayerTheme ? 'white' : undefined}
      />
    ) : (
      <AudioActionButton
        playing={isPlaying}
        isActive={isActive}
        onClick={handlePlay}
        data-testid={dataTestId || 'audio-play-button'}
        size={20}
        playIconTestId="audio-play-icon"
        isLoading={isLoading}
        isPlayerTheme={isPlayerTheme}
        variant="audio"
      />
    )}
  </ListItem>
);
